import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';
import { t } from 'c-3po';

import * as a from './../../../../libs/actions';
import * as c from './../../../../libs/constants';
import { getClientEditUrl } from './../../../../libs/helpers/prom';
import { getSocketStore } from './../../../../libs/utils';
import { toJS } from '../../../helpers/ImmutableToJS';


import { Rating } from '../../../ui/rating';

import { Notice } from '../../../ui/notice';
import { Button } from '../../../ui/button';
import { Icon } from '../../../ui/icon';

// styles
import css from './clientBody.sss';

// images
import ErrorNoticePng from './images/errorNotice.png';
import PhoneIconSvg from './images/phone.icon.svg';
import MailIconSvg from './images/mail.icon.svg';
import UserIconSvg from './images/user.icon.svg';
import OpinionIconSvg from './images/opinion.icon.svg';
import SmileIconSvg from './images/smile.icon.svg';
import MoreHorizontalIconSvg from './images/moreHorizontal.icon.svg';
import PencilIconSvg from './images/pencil.icon.svg';


class BodyView extends React.Component {

    static propTypes = {
        notification: PropTypes.object,
        clientInfo: PropTypes.object,
        clientsUserId: PropTypes.string,
        isNewCabinet: PropTypes.bool,
        modifiedClientRoom: PropTypes.object,
    };

    handleProceedTab = () => {
        this.props.send(a.EVENT_CLIENT_CHANGE_TAB,
            { tabName: c.CHAT_CLIENT_BAN });
    }

    render() {
        const { clientInfo, notification, clientsUserId, isNewCabinet, modifiedClientRoom } = this.props;

        const clientEditUrl = getClientEditUrl(clientsUserId, isNewCabinet);

        if (notification.error === c.NOTIFICATION_ERROR_CLIENT_INFO) {
            return (
                <Notice
                    image={ErrorNoticePng}
                    title={t`Что-то пошло не так...`}
                >
                    {t`При выполнении вашего запроса произошла внутренняя ошибка`}
                </Notice>
            );
        }

        const filterByType = (type) => (contact) => contact.type === type;

        const additionalPhones = (clientInfo.additional_contacts || []).filter(filterByType('phone'));
        const additionalEmails = (clientInfo.additional_contacts || []).filter(filterByType('email'));
        const additionalContOther = (clientInfo.additional_contacts || []).filter(
            (contact) => !['phone', 'email'].includes(contact.type));

        return (
            <div className={css.root} data-qaid='client_info_block'>
                <div className={css.content}>
                    {!clientInfo.notFound ? (
                        <React.Fragment>
                            <div name='baseInfo' className={css.contentBlock}>
                                <div className={css.row}>
                                    <div className={css.iconHolder}>
                                        <Icon className={css.icon} glyph={UserIconSvg} />
                                    </div>
                                    <div className={css.valueHolder}>
                                        <div className={css.valueLine}>
                                            <a
                                                href={clientEditUrl}
                                                className={css.userName}
                                                data-qaid='client_name'
                                            >
                                                {clientInfo.name ? clientInfo.name : 'Имя не указано'}
                                            </a>
                                            <div className={css.ordersStat}>
                                                {clientInfo.num_orders ? (
                                                    <span>
                                                        {t`${clientInfo.num_orders} заказа на сумму
                                                         ${clientInfo.total_payout} в вашем магазине`}
                                                    </span>
                                                ) : (
                                                    <span>{t`Еще нет оплаченных заказов`}</span>
                                                )}
                                            </div>
                                            <div className={css.ratingHolder}>
                                                {!!clientInfo.num_opinions ? (
                                                    <React.Fragment>
                                                        <div className={css.ratingStars}>
                                                            <Rating rating={this.props.clientInfo.avg_rating} />
                                                        </div>
                                                        <ul className={css.ratingStats}>
                                                            <li className={css.ratingStatsItem}>
                                                                <Icon
                                                                    className={css.ratingStatsIcon}
                                                                    glyph={OpinionIconSvg}
                                                                />
                                                                <span className={css.ratingStatsValue}>
                                                                    {clientInfo.num_opinions}
                                                                </span>
                                                            </li>
                                                            <li className={css.ratingStatsItem}>
                                                                <Icon
                                                                    className={css.ratingStatsIcon}
                                                                    glyph={SmileIconSvg}
                                                                />
                                                                <span className={css.ratingStatsValue}>
                                                                    {clientInfo.positive_rating_percent}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </React.Fragment>
                                                ) : (
                                                    <span className={css.ratingPlaceholder}>
                                                        {t`О этом покупателе еще нет отзывов`}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className={css.valueLine} name='orderData'>
                                            <a
                                                className={css.link}
                                                href={`${clientEditUrl}#${c.ACTION_HASH_CLIENT_OPINION}`}
                                                target='_blank'
                                                data-qaid='add_client_opinion'
                                            >
                                                {t`Оставить отзыв о покупателе`}
                                            </a>
                                            <ul name='Marks' className={css.labels}>
                                                {clientInfo.labels.length > 0 ? (
                                                    clientInfo.labels.map((label) => (
                                                        <li className={css.labelItem}>
                                                            {label.name}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className={css.labelItem}>
                                                        {t`Нет добавленных меток`}
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={css.contentBlock}>
                                {!!clientInfo.phone && (
                                    <div className={css.row}>
                                        <div className={css.iconHolder}>
                                            <Icon
                                                className={css.icon}
                                                glyph={PhoneIconSvg}
                                            />
                                        </div>
                                        <div className={css.valueHolder}>
                                            {!!clientInfo.phone && (
                                                <div className={css.valueLine}>
                                                    <a
                                                        href={`tel:${clientInfo.phone}`}
                                                        className={css.link}
                                                        data-qaid='client_phone'
                                                    >
                                                        {clientInfo.phone}
                                                    </a>
                                                </div>
                                            )}
                                            {additionalPhones.map((phoneObj) => (
                                                <div className={css.valueLine}>
                                                    <a href={`tel:${phoneObj.value}`} className={css.link}>
                                                        {phoneObj.value}
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {!!clientInfo.email && (
                                    <div className={css.row}>
                                        <div className={css.iconHolder}>
                                            <Icon
                                                className={css.icon}
                                                glyph={MailIconSvg}
                                            />
                                        </div>
                                        <div className={css.valueHolder}>
                                            <div className={css.valueLine}>
                                                <a
                                                    href={`mailto:${clientInfo.email}`}
                                                    className={css.link}
                                                    data-qaid='client_email'
                                                >
                                                    {clientInfo.email}
                                                </a>
                                            </div>
                                            {additionalEmails.map((emailObj) => (
                                                <div className={css.valueLine}>
                                                    <a href={`mailto:${emailObj.value}`} className={css.link}>
                                                        {emailObj.value}
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {additionalContOther.length > 0 && (
                                    <div className={css.row}>
                                        <div className={css.iconHolder}>
                                            <Icon
                                                className={css.icon}
                                                glyph={MoreHorizontalIconSvg}
                                            />
                                        </div>
                                        <div className={css.valueHolder}>
                                            {additionalContOther.map((contact) => (
                                                <div className={css.valueLine}>
                                                    <span>{contact.type}: </span>
                                                    <span>{contact.value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <div name='Notes' className={css.row}>
                                    <div className={css.iconHolder}>
                                        <a
                                            className={css.iconLink}
                                            href={`${clientEditUrl}#${c.ACTION_HASH_CLIENT_COMMENT}`}
                                            title={t`Редактировать`}
                                            target='_blank'
                                        >
                                            <Icon
                                                className={css.icon}
                                                glyph={PencilIconSvg}
                                            />
                                        </a>
                                    </div>
                                    <div className={css.valueHolder}>
                                        {clientInfo.comment ? (
                                            <div
                                                className={css.valueLine}
                                                data-qaid='notes_about_client'
                                            >
                                                {clientInfo.comment}
                                            </div>
                                        ) : (
                                            <div className={css.valueLinePlaceholder}>
                                                {t`Вы пока ничего не написали`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <Notice>
                            {t`Для этого пользователя, еще не был создан клиент`}
                        </Notice>
                    )}
                </div>
                {!modifiedClientRoom.clientBanned && (
                    <div
                        className={css.footer}
                        name='clientButtonSectionChat'
                    >
                        <Button
                            onClick={this.handleProceedTab}
                            dataQa='ban_client_btn'
                        >
                            {t`Заблокировать`}
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const modifiedClientRoom = getRoom(socketStore, state.get('prevOpenedRoomIdent'));

    return {
        clientInfo: state.get('clientInfo'),
        clientsUserId: state.get('clientsUserId'),
        notification: state.get('notification'),
        isNewCabinet: state.get('isNewCabinet'),
        modifiedClientRoom,
    };
};

export const Body = connect(mapStateToProps)(toJS(BodyView));
